/**
 * @file InstallationInstructions.js
 * @description A component to display installation instructions for mobile apps based on the user's device.
 */

import React, { useEffect, useState } from 'react';
import { isMobileDevice, isAndroid, isIOS } from '../../utils/deviceCheck';
import QRCode from 'react-qr-code';
import { getText } from '../../i18n';

const InstallationInstructions = () => {
    const [isMobile, setIsMobile] = useState(null);
    const [selectedPlatform, setSelectedPlatform] = useState(null); //'Android' or 'iOS'
    const companyCode = window.localStorage.getItem('companyCode');
    const loginUrl = `${window.location.origin}/login${companyCode ? `?companyCode=${companyCode}` : ''}`;

    useEffect(() => {
        const loadDeviceInfo = async () => {
            const mobile = await isMobileDevice();
            setIsMobile(mobile);
            if (mobile) {
                if (isAndroid()) {
                    setSelectedPlatform('Android');
                } else if (isIOS()) {
                    setSelectedPlatform('iOS');
                } else {
                    setSelectedPlatform('iOS'); // Default to iOS if not mobile
                }
            } else {
                setSelectedPlatform('iOS'); // Default to iOS
            }
        };
        loadDeviceInfo();
    }, []);

    const renderQRCode = () => {
        const companyCode = window.localStorage.getItem('companyCode');
        const loginUrl = `${window.location.origin}/login${companyCode ? `?companyCode=${companyCode}` : ''}`;

        if (isMobile === false) {
            return (
                <div
                    style={{
                        height: 'auto',
                        maxWidth: '160px',
                        width: 'fit-content',
                        background: '#F0F0F0',
                        padding: '10px',
                        border: '1px #DBDBDB solid',
                        marginBottom: '18px',
                        display: 'flex',
                        justifyContent: 'flex-start',
                        alignItems: 'flex-start',
                    }}
                >
                    <QRCode
                        size={256}
                        style={{
                            height: 'auto',
                            maxWidth: '100%',
                            width: '100%',
                            backgroundColor: 'white',
                        }}
                        value={loginUrl}
                        viewBox={`0 0 256 256`}
                    />
                </div>
            );
        }
        return null;
    };

    const displayedInstructions = () => {
        const iOSInstructions = (
            <>
                <h4 style={styles.title}>{getText('msg_a5a8e0bbb737')}</h4>

                <ol style={styles.list}>
                    {isMobile ? (
                        <></>
                    ) : (
                        <>
                            <li style={styles.listItem}>
                                {getText('msg_90cc1eacafe6')}
                                <p style={styles.paragraph}>
                                    {getText('msg_831c6ea39b41')}
                                    <br />
                                    {getText('msg_6a9b4153c0eb')}
                                    <br/>
                                    {/* <a
                                        href={loginUrl}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        style={styles.urlLink}
                                    > */}
                                    <div style={styles.urlLink}>
                                        {loginUrl}
                                        </div>
                                    {/* </a> */}
                                    {getText('msg_ffb3b2c40976')}
                                    <br />
                                    {getText('msg_9f8cdc407ae4')}
                                </p>
                                {renderQRCode()}
                            </li>
                        </>
                    )}
                    <li style={styles.listItem}>
                        {getText('msg_1b4107db4a21')}
                        <p style={styles.paragraph}>
                            {isMobile ? (
                                <>
                                    {getText('msg_a226669c3beb')}
                                    <br />
                                </>
                            ) : (
                                <>
                                    {getText('msg_df8be4c0d8b3')}
                                    <br />
                                </>
                            )}
                            {getText('msg_135a69ae6a56')}{' '}
                            <i className="bi bi-box-arrow-up"></i>.
                        </p>
                    </li>
                    <li style={styles.listItem}>
                        {getText('msg_7bd938bc58f9')}
                        <p style={styles.paragraph}>
                            {getText('msg_68f51eeab09c')}
                        </p>
                    </li>
                    <li style={styles.listItem}>
                        {getText('msg_e6402a1d9111')}
                        <p style={styles.paragraph}>
                            {getText('msg_2724d49bbcf7')}
                        </p>
                    </li>
                    <li style={styles.listItem}>
                        {getText('msg_a995e1a56406')}
                        <p style={styles.paragraph}>
                            {getText('msg_f18fe4ac0358')}
                        </p>
                    </li>
                    <li style={styles.listItem}>
                        {getText('msg_d527bf3db3dc')}
                        <p style={styles.paragraph}>
                            {getText('msg_591ec5a8d5bf')}
                        </p>
                    </li>
                </ol>
            </>
        );

        const androidInstructions = (
            <>
                <h4 style={styles.title}>{getText('msg_46025150b626')}</h4>

                <ol style={styles.list}>
                    {isMobile ? (
                        <></>
                    ) : (
                        <li style={styles.listItem}>
                            {getText('msg_90cc1eacafe6')}
                            <p style={styles.paragraph}>
                                {getText('msg_46273f3346e9')}
                                <br />
                                {getText('msg_6a9b4153c0eb')}
                                <br />
                                {/* <a
                                    href={loginUrl}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    style={styles.urlLink}
                                > */}
                                <div style={styles.urlLink}>
                                    {loginUrl}
                                    </div>
                                {/* </a> */}
                                {getText('msg_ffb3b2c40976')}
                                <br />
                                {getText('msg_9f8cdc407ae4')}
                            </p>
                            {renderQRCode()}
                        </li>
                    )}
                    <li style={styles.listItem}>
                        {getText('msg_af99596d757f')}
                        <p style={styles.paragraph}>
                            {isMobile ? (
                                <>
                                    {getText('msg_7cb4e9d25b9d')}{' '}
                                    <i className="bi bi-three-dots-vertical"></i>{' '}
                                    {getText('msg_69a9eabc8640')}
                                </>
                            ) : (
                                <>
                                    {getText('msg_30cd53e34e96')}{' '}
                                    <i className="bi bi-three-dots-vertical"></i>{' '}
                                    {getText('msg_69a9eabc8640')}
                                </>
                            )}
                        </p>
                    </li>
                    <li style={styles.listItem}>
                        {getText('msg_7bd938bc58f9')}
                        <p style={styles.paragraph}>
                            {getText('msg_68f51eeab09c')}
                        </p>
                    </li>
                    <li style={styles.listItem}>
                        {getText('msg_6dcd917b20ef')}
                        <p style={styles.paragraph}>
                            {getText('msg_390b40faf50d')}
                        </p>
                    </li>
                    <li style={styles.listItem}>
                        {getText('msg_e6402a1d9111')}
                        <p style={styles.paragraph}>
                            {getText('msg_785d1b3120be')}
                        </p>
                    </li>
                    <li style={styles.listItem}>
                        {getText('msg_a995e1a56406')}
                        <p style={styles.paragraph}>
                            {getText('msg_f18fe4ac0358')}
                        </p>
                    </li>
                    <li style={styles.listItem}>
                        {getText('msg_d527bf3db3dc')}
                        <p style={styles.paragraph}>
                            {getText('msg_591ec5a8d5bf')}
                        </p>
                    </li>
                </ol>
            </>
        );

        if (selectedPlatform === 'Android') {
            return androidInstructions;
        } else if (selectedPlatform === 'iOS') {
            return iOSInstructions;
        } else {
            return iOSInstructions; // Default to iOS
        }
    };

    return (
        <>
            <div style={styles.buttonContainer}>
                <p
                    style={{
                        ...styles.button,
                        borderBottom:
                            selectedPlatform === 'Android'
                                ? '2px solid var(--iNGAGED-Primary-Color)'
                                : 'none',
                        color:
                            selectedPlatform === 'Android'
                                ? 'var(--iNGAGED-Primary-Color)'
                                : 'black',
                        fontWeight:
                            selectedPlatform === 'Android' ? '600' : '500',
                    }}
                    onClick={() => {
                        setSelectedPlatform('Android');
                    }}
                >
                    {getText('msg_1928f95c598b')}
                </p>
                <p
                    style={{
                        ...styles.button,
                        borderBottom:
                            selectedPlatform === 'iOS'
                                ? '2px solid var(--iNGAGED-Primary-Color)'
                                : 'none',
                        color:
                            selectedPlatform === 'iOS'
                                ? 'var(--iNGAGED-Primary-Color)'
                                : 'black',
                        fontWeight: selectedPlatform === 'iOS' ? '600' : '500',
                    }}
                    onClick={() => {
                        setSelectedPlatform('iOS');
                    }}
                >
                    {getText('msg_6413e837d316')}
                </p>
            </div>
            <div style={styles.textBlock}>{displayedInstructions()}</div>
        </>
    );
};

const styles = {
    header: {
        marginBottom: '30px',
        fontWeight: '600',
        fontSize: '22px',
    },
    buttonContainer: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center',
        margin: '20px auto 46px',
        width: '100%',
        maxWidth: '372px',
    },
    button: {
        flex: '1 1 0',
        minWidth: 0,
        maxWidth: '186px',
        textAlign: 'center',
        padding: '18px',
        cursor: 'pointer',
    },
    textBlock: {
        textAlign: 'left',
    },
    title: {
        marginBottom: '30px',
        fontWeight: '600',
        fontSize: '24px',
    },
    paragraph: {
        paddingBottom: '18px',
        fontSize: '16px',
        lineHeight: '27px',
        fontWeight: '500',
    },
    list: {
        listStyleType: 'decimal',
        padding: 0,
        margin: 0,
        listStylePosition: 'inside',
    },
    listItem: {
        margin: 0,
        padding: 0,
        fontWeight: '600',
    },
    urlLink: {
        fontWeight: '600',
        color: '#136FFF',
        fontSize: '16px',
        textDecoration: 'underline',
        userSelect: 'text'
      },
};

export default InstallationInstructions;
